var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin-settings text-center"},[_c('div',{staticClass:"btnGroup"}),_c('div',{staticStyle:{"border":"1px dashed lightgrey","text-align":"center","display":"inline-block"}},[_c('table',[_c('tbody',[_c('tr',[_c('td'),_c('td',[_c('drag-input-unit',{style:({background:['white','#a0ffa0','whitesmoke'][_vm.currentGroup]}),attrs:{"value":_vm.styleJSON.marginTop,"icon":"arrow-to-top"},on:{"input":function (value){
                            		_vm.setStyle({marginTop:value});
                            		if(_vm.currentGroup === 1){
                            			_vm.setStyle({marginBottom:value});
                            		}
                            		if(_vm.currentGroup === 2 ){
                            			_vm.setStyle({
                            				marginLeft:value,
                            				marginBottom:value,
                            				marginRight:value
                            			});
                            		}
                            	}}})],1),_c('td')]),_c('tr',[_c('td',[_c('drag-input-unit',{style:({background:['white','#b7f7ff','whitesmoke'][_vm.currentGroup]}),attrs:{"value":_vm.styleJSON.marginLeft,"icon":"arrow-to-left"},on:{"input":function (value){
                            		_vm.setStyle({marginLeft:value});
                            		if(_vm.currentGroup === 1){
                            			_vm.setStyle({marginRight:value});
                            		}
                            		if(_vm.currentGroup === 2 ){
                            			_vm.setStyle({
                            				marginTop:value,
                            				marginBottom:value,
                            				marginRight:value
                            			});
                            		}
                            	}}})],1),_c('td',[_c('div',{staticStyle:{"border":"1px solid grey","padding":"6px 6px","display":"inline-block"}},_vm._l((['expand','arrows','square']),function(icon,index){return _c('btn',{key:index,attrs:{"icon":icon,"s":"xs","active":_vm.currentGroup === index},on:{"press":function($event){_vm.currentGroup = index}}})}))]),_c('td',[_c('drag-input-unit',{style:({background:['white','#b7f7ff','whitesmoke'][_vm.currentGroup]}),attrs:{"value":_vm.styleJSON.marginRight,"icon":"arrow-to-right"},on:{"input":function (value){
                            		_vm.setStyle({marginRight:value});
                            		if(_vm.currentGroup === 1){
                            			_vm.setStyle({marginLeft:value});
                            		}
                            		if(_vm.currentGroup === 2 ){
                            			_vm.setStyle({
                            				marginLeft:value,
                            				marginBottom:value,
                            				marginTop:value
                            			});
                            		}
                            	}}})],1)]),_c('tr',[_c('td'),_c('td',[_c('drag-input-unit',{style:({background:['white','#a0ffa0','whitesmoke'][_vm.currentGroup]}),attrs:{"value":_vm.styleJSON.marginBottom,"icon":"arrow-to-bottom"},on:{"input":function (value){
                            		_vm.setStyle({marginBottom:value});
                            		if(_vm.currentGroup === 1){
                            			_vm.setStyle({marginTop:value});
                            		}
                            		if(_vm.currentGroup === 2 ){
                            			_vm.setStyle({
                            				marginLeft:value,
                            				marginRight:value,
                            				marginTop:value
                            			});
                            		}

                            	}}})],1),_c('td')])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }